import { IModel, Model, ModelRecord, IPhotoModel, PhotoModel } from "@common/models";
import { DateTimeUtils } from "@common/utils";
import { DateTime } from "luxon";

export interface IClientCommunicationListingModel extends IModel {
    communicationId: number;
    communicationMethodId: number;
    communicationDirectionId: number;
    content: string;
    storeId: number | undefined;
    storeName: string | undefined;
    dateCreated: string;
    readDate: string | undefined;
    readByName:string | undefined;
    sentByName: string | undefined;
    outboundSentByName: string | undefined;
    photos: IPhotoModel[];
}

export class ClientCommunicationListingModel extends Model implements ModelRecord<IClientCommunicationListingModel> {
    communicationId: number;
    communicationMethodId: number;
    communicationDirectionId: number;
    content: string;
    storeId: number | undefined;
    storeName: string | undefined;
    dateCreated: DateTime;
    readDate: DateTime | undefined;
    readByName:string | undefined;
    sentByName: string | undefined;
    outboundSentByName: string | undefined;
    photos: IPhotoModel[];

    constructor(params?: Partial<IClientCommunicationListingModel>){
        super(params);
        this.communicationId = _.defaultTo(params?.communicationId, 0);
        this.communicationMethodId = _.defaultTo(params?.communicationMethodId, 0);
        this.communicationDirectionId = _.defaultTo(params?.communicationDirectionId, 0);
        this.content = _.defaultTo(params?.content, "");
        this.storeId = _.defaultTo(params?.storeId, 0);
        this.storeName = _.defaultTo(params?.storeName, "");
        this.dateCreated = DateTimeUtils.getAsDateTimeUTC(params?.dateCreated)!
        this.readDate = DateTimeUtils.getAsDateTimeUTC(params?.readDate)!
        this.sentByName = _.defaultTo(params?.sentByName??params?.outboundSentByName, "");
        this.readByName = _.defaultTo(params?.readByName, "");
        this.photos = params?.photos ? params?.photos.map(p => new PhotoModel(p)) : [] as PhotoModel[];
    }
}
